import {TweenLite} from "gsap";

class Bubbles {
    constructor() {
        this.duration = 1.5
        this.activeBubble = 0
        this.container = document.querySelector('.nav-bubbles')
        this.els = this
            .container
            .querySelectorAll('[data-bubble]');
        this.elLines = this
            .container
            .querySelectorAll('.nav-bubbles__line')
        this.totalBubbles = this.els.length
        this.testMode = false
    }

    init() {
        if (this.testMode) {
            setInterval(() => {
                this.activeBubble++;
                if (this.activeBubble === this.totalBubbles) {
                    this.activeBubble = 0;
                }
                this.changeBubble();
                this.changeLine();
            }, 2000);
        }

        this.changeBubble()
        this.prepareLines()
        this.changeLine()
        this.animateBubbles()
    }

    animateBubbles() {
        TweenLite.fromTo(this.container, this.duration, {
            right: 0 + 'px'
        }, {
            opacity: 1,
            right: 50 + 'px',
            ease: Quint.easeInOut,
            force3D: true
        })
    }

    prepareLines() {
        Array.from(this.elLines, (l, index) => {
            l.style.top = 8 + index * 37 + "px"
        });

    }

    changeBubble() {

        const prevActiveEl = document.querySelector('.nav-bubbles__item--active');
        if (prevActiveEl) {
            prevActiveEl
                .classList
                .remove('nav-bubbles__item--active');
        }

        const activeEl = document.querySelector("[data-bubble='" + this.activeBubble + "']");
        activeEl
            .classList
            .add('nav-bubbles__item--active');
    }

    goTo(id) {
        this.activeBubble = id;

        this.changeBubble();
        this.changeLine();
    }

    changeLine() {
        const topBottomClass = 'nav-bubbles__line--top-bottom';
        const outClass = 'nav-bubbles__line--out';

        Array.from(this.elLines, (l, index) => {
            l
                .classList
                .remove(topBottomClass);
            l
                .classList
                .remove(outClass);
            if (index < this.activeBubble - 1 || index >= this.activeBubble + 1) {
                l
                    .classList
                    .add(outClass);
            }
        });

        const newLine = (this.activeBubble !== this.totalBubbles)
            ? document.querySelector("[data-bubble-line='" + this.activeBubble + "']")
            : null;
        if (newLine) {
            newLine
                .classList
                .add(topBottomClass);
        }

    }
}

export default Bubbles


// WEBPACK FOOTER //
// ./src/js/components/Bubbles.js